module.exports = __webpack_public_path__ + "img/img11.d33dfef6.svg";